import guideMd from "../../DASHBOARD_README.md?raw";

type Node =
  | { type: "h1" | "h2" | "h3"; text: string }
  | { type: "p"; text: string }
  | { type: "li"; text: string };

function parseMarkdown(md: string): Node[] {
  const lines = md.replace(/\r\n/g, "\n").split("\n");
  const out: Node[] = [];
  let para: string[] = [];

  function flushPara() {
    if (para.length === 0) return;
    const text = para.join(" ").trim();
    if (text) out.push({ type: "p", text });
    para = [];
  }

  for (const raw of lines) {
    const line = raw.trim();
    if (!line) {
      flushPara();
      continue;
    }
    if (line.startsWith("### ")) {
      flushPara();
      out.push({ type: "h3", text: line.slice(4).trim() });
      continue;
    }
    if (line.startsWith("## ")) {
      flushPara();
      out.push({ type: "h2", text: line.slice(3).trim() });
      continue;
    }
    if (line.startsWith("# ")) {
      flushPara();
      out.push({ type: "h1", text: line.slice(2).trim() });
      continue;
    }
    if (line.startsWith("- ")) {
      flushPara();
      out.push({ type: "li", text: line.slice(2).trim() });
      continue;
    }
    para.push(line);
  }
  flushPara();
  return out;
}

function renderInline(text: string) {
  const parts = text.split(/(`[^`]+`)/g).filter(Boolean);
  return parts.map((part, i) => {
    if (part.startsWith("`") && part.endsWith("`")) {
      return (
        <code
          key={i}
          className="px-1.5 py-0.5 rounded bg-pp-soft border border-pp-border text-[0.95em]"
        >
          {part.slice(1, -1)}
        </code>
      );
    }
    return <span key={i}>{part}</span>;
  });
}

export default function AdminGuide() {
  const nodes = parseMarkdown(guideMd);

  return (
    <section className="space-y-3">
      <div className="border rounded-lg p-4 bg-pp-card">
        <p className="text-sm font-medium text-pp-main">Guia de lectura del dashboard</p>
        <p className="text-xs text-pp-muted mt-1">
          Documento interno para alinear como interpretar KPIs, embudos, drivers y price fit.
        </p>
      </div>
      <article className="border rounded-lg bg-pp-card p-4">
        <div className="max-w-3xl text-sm text-pp-main leading-7">
          {nodes.map((n, idx) => {
            if (n.type === "h1") {
              return (
                <h1 key={idx} className="text-2xl font-semibold tracking-tight text-pp-main mt-2 mb-4">
                  {renderInline(n.text)}
                </h1>
              );
            }
            if (n.type === "h2") {
              return (
                <h2 key={idx} className="text-xl font-semibold text-pp-main mt-8 mb-3 border-b pb-1">
                  {renderInline(n.text)}
                </h2>
              );
            }
            if (n.type === "h3") {
              return (
                <h3 key={idx} className="text-base font-semibold text-pp-main mt-6 mb-2">
                  {renderInline(n.text)}
                </h3>
              );
            }
            if (n.type === "li") {
              return (
                <p key={idx} className="mb-1.5 text-pp-muted pl-5 relative">
                  <span className="absolute left-0 text-pp-quiet">•</span>
                  {renderInline(n.text)}
                </p>
              );
            }
            return (
              <p key={idx} className="mb-3 text-pp-muted">
                {renderInline(n.text)}
              </p>
            );
          })}
        </div>
      </article>
    </section>
  );
}
